import React from "react";

const Alert = ({ errorToast, message, handleClose }) => {
  return (
    <div className={`toast-container ${errorToast && "toast-error"}`}>
      <span className="ico">
        {errorToast ? (
          <img
            src={require("assets/images/error-close.svg").default}
            className="img-fluid"
            alt="error"
          />
        ) : (
          <img
            src={require("assets/images/tick.svg").default}
            className="img-fluid"
            alt="tick"
          />
        )}
      </span>
      <p>{message}</p>
      <span className="close-ico" onClick={handleClose}>
        <img
          src={require("assets/images/close.svg").default}
          className="img-fluid"
          alt="close"
        />
      </span>
    </div>
  );
};

export default Alert;
